<template>
<header id="header" :class="{'is-collapsed' : collapsed}">
    <TopStripe v-if="$store.state.site_data.siteconfig.notification" :notification="$store.state.site_data.siteconfig.notification" />
    <div :class="['header-wrapper', {'is-collapsed' : header_collapsed}]">
        <div class="header section">
            <div class="container">
                <div class="columns header-main is-mobile">
                    <h1 class="column is-narrow" v-if="$route.name == 'Homepage'">
                        <router-link class="logo" rel="start" v-if="$store.state.site_data.siteconfig.logo" :to="{ name: 'Homepage' }"><img :src="$store.state.site_data.siteconfig.logo.url" :alt="$store.state.site_data.siteconfig.title" /></router-link>
                        <router-link v-else :to="{ name: 'Homepage' }">{{$store.state.site_data.siteconfig.title}}</router-link>
                    </h1>
                    <div class="column is-narrow" v-else>
                        <router-link class="logo" rel="start" v-if="$store.state.site_data.siteconfig.logo" :to="{ name: 'Homepage' }"><img :src="$store.state.site_data.siteconfig.logo.url" :alt="$store.state.site_data.siteconfig.title" /></router-link>
                        <router-link v-else :to="{ name: 'Homepage' }">{{$store.state.site_data.siteconfig.title}}</router-link>
                    </div>
                    <div class="column search-form-holder">
                        <MiniSearchform />
                    </div>
                    <div class="column is-narrow">
                        <MiniCart />
                    </div>
                </div>
            </div>
        </div>
    </div>
    <Navigation />
    <div class="container">
        <MiniCartDetails ref="cart_pane" />
    </div>
</header>
</template>
<script>
import TopStripe from './TopStripe';
import MiniCart from './elements/MiniCart';
import Navigation from './Navigation';
import MiniSearchform from './elements/MiniSearchform';
import MiniCartDetails from './elements/MiniCartDetails';
export default {
    name: 'Header',
    components  :   { TopStripe, MiniCart, Navigation, MiniCartDetails, MiniSearchform },
    data: function() {
        return {
            // collapsed: false,
            header_collapsed: false,
            mobile_menu_is_active: false,
            slide_out: false
        }
    },
    computed    :   {
        collapsed()
        {
            if (this.$store.state.offset >= this.offset_top) {
                this.$bus.$emit('onToggleMenu', true);
                return true;
            }
            this.$bus.$emit('onToggleMenu', false);
            return false;
        },
        offset_top()
        {
            if (this.$route.name == 'Homepage') {
                return 224;
            }

            return 156;
        },

    },
    watch: {
        collapsed(nv, ov) {
            if (this.$refs.cart_pane.show) {
                this.$refs.cart_pane.show =   false;
            }
        },
        mobile_menu_is_active(nv, ov) {
            let me  =   this;
            if (nv) {
                setTimeout(function () {
                    me.slide_out    =   true;
                }, 10);
            }
        },
        slide_out(nv, ov) {
            let me  =   this;
            if (!nv) {
                setTimeout(function () {
                    me.mobile_menu_is_active    =   false;
                }, 300);
            }
        }
    },
    methods: {

    }
}
</script>



// WEBPACK FOOTER //
// src/components/blocks/Header.vue